/// <reference path="../../types/luv/index.d.ts" />

class Parser {
    //TODO: add multilingualism
    private static i18n = {
        'no_date_delivered': 'Kein Datum angegeben',
    };
    /** formats Date object into human-better-understandable string
     * because of loading the datetimeutil via sod, the first call is async
     * the cb is a callback, which gets the formates string
     * set forceIncludeTime, to force the include of time into the result, otherwise it ignores the time if hour, minutes and seconds are 0
    */
    public humanizeDate(date: Date, cb: Function, forceIncludeTime: boolean = false) {
        if (!date || isNaN(date.getTime())) {
            cb(Parser.i18n.no_date_delivered);
            return;
        }
        SP.SOD.registerSod("sp.datetimeutil.js", requirejs.toUrl("/_layouts/15/sp.datetimeutil.js"));
        SP.SOD.executeFunc("sp.datetimeutil.js", "SP.DateTimeUtil.SPRelativeDateTime", () => {
            const withTime = date.getHours() + date.getMinutes() + date.getSeconds() > 0;
            cb(SP.DateTimeUtil.SPRelativeDateTime.getRelativeDateTimeString(date, forceIncludeTime || withTime, SP.DateTimeUtil.SPCalendarType.none, false));
            //replace the humanizeDate with a syncronous version without sod, because sp.datetimeutil.js was loaded now
            Parser.prototype.humanizeDate = (date: Date, cb: Function, forceIncludeTime: boolean) => {
                if (!date || isNaN(date.getTime())) {
                    cb(Parser.i18n.no_date_delivered);
                    return;
                }
                const withTime2 = date.getHours() + date.getMinutes() + date.getSeconds() > 0;
                cb(SP.DateTimeUtil.SPRelativeDateTime.getRelativeDateTimeString(date, forceIncludeTime || withTime2, SP.DateTimeUtil.SPCalendarType.none, false));
            };
        });
    }
}
export default new Parser();
